import React, { useEffect, useState } from "react";
import { AiOutlineArrowRight, AiOutlineClose } from "react-icons/ai";
import { condition } from "context/condition";
import { Globalstate } from "context/context";
import "./autoCompleteInput.css";
import assetsMaanager from "assets/assetsmanager/assestsmanager";
import { IoIosSquare } from "react-icons/io";

const AutoCompleteInput = ({
  setIsFocused,
  handleSubmit,
  inputRef,
  value,
  setValue,
  showCrossIcon,
  handlePause,
  isChatLoading
}) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const { dispatch, state } = Globalstate();
  const { autocompleteData, isMessageSubmitted } = state;
  useEffect(() => {
    const input = inputRef?.current;
    input?.addEventListener("focus", () => {
      input.classList.add("focused");
      setIsFocused(true);
    });
    input?.addEventListener("blur", () => {
      setTimeout(() => {
        input.classList.remove("focused");
        setIsFocused(false);
      }, 0);
    });
  }, [setIsFocused]);

  useEffect(() => {
    setValue(state?.transcription);
  }, [state?.transcription]);

  const handleSearchText = (newInputValue) => {
    setValue(newInputValue);
  };
  const handleClear = () => {
    dispatch({ type: condition.SETAUTOCOMPLETEDATA, payload: [] });
    setValue("");
  };
  const handleEscpaeKey = () => {
    dispatch({ type: condition.SETAUTOCOMPLETEDATA, payload: [] });
  };

  return (
    <>
      <div className="autocomplete-container">
        {showSuggestions && (
          <div className="autocomplete-content">
            {autocompleteData.map((item, index) => (
              <a
                href={item.source}
                target="_blank"
                rel="noreferrer"
                key={index}
                className="autocomplete-item"
                onMouseDown={(e) => {
                  e.stopPropagation();
                  window.open(item.source, "_blank");
                }}
              >
                <div className="autocomplete-item-title">
                  <p>{item.title}</p>
                </div>
                <div className="autocomplete-item-arrow">
                  <AiOutlineArrowRight />
                </div>
              </a>
            ))}
          </div>
        )}
        <img
          src={assetsMaanager.searchIcon}
          className="input-search-icon"
          alt=""
        />
        <input
          autoComplete="off"
          onKeyDown={(e) => {
            e.key === "Enter" && handleSubmit(value);
            e.key === "Escape" && handleEscpaeKey();
          }}
          type="text"
          placeholder="Ask Me Anything"
          name="message"
          value={value}
          onChange={(e) => {
            handleSearchText(e.target.value);
          }}
          onBlur={() => {
            setShowSuggestions(false);
          }}
          ref={inputRef}
          disabled={isMessageSubmitted}
        />

        {(isMessageSubmitted && state?.nudgeFlow) ? (
          <IoIosSquare onClick={handlePause} className="input-pause-icon" color="#797979" size={22} />
        ) : (
          <img
            className="input-send-icon"
            src={assetsMaanager.sendArrow}
            alt=""
            onClick={() => handleSubmit(value)}
          />
        )}
        {autocompleteData.length > 0 && showCrossIcon && (
          <AiOutlineClose className="input-close-icon" onClick={handleClear} />
        )}
      </div>
    </>
  );
};

export default AutoCompleteInput;
